import { AxiosResponse } from 'axios';
import $http from 'services/http.service';
import { clientId, redirectUri } from 'utils/helper.utils';

type ValidateClientAccessResponse = {
  clientId: string;
  clientName: string;
};

export async function validateClientAccess(): Promise<AxiosResponse<ValidateClientAccessResponse>> {
  const response = await $http.get<ValidateClientAccessResponse>('/validate-client-access', {
    headers: {
      'client-id': clientId,
      'redirect-uri': redirectUri
    }
  });

  return response;
}
